import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiState } from '../../../models/generics';
import { TCart } from '@/services/cart/models/cart';

interface CartState {
  cart: TCart | null;
  status: ApiState;
  error: string;
}

const initialState: CartState = {
  cart: null,
  status: ApiState.IDLE,
  error: '',
};

// Create the slice with simple reducers
const unlmtdCartSlice = createSlice({
  name: 'unlmtdCart',
  initialState,
  reducers: {
    cartLoading: (state) => {
      state.status = ApiState.LOADING;
    },
    cartSuccess: (state, action: PayloadAction<TCart>) => {
      state.status = ApiState.SUCCESS;
      state.cart = action.payload;
      state.error = '';
    },
    cartError: (state, action: PayloadAction<string>) => {
      state.status = ApiState.FAILED;
      state.error = action.payload;
    },
    clearCart: (state) => {
      state.cart = null;
      state.status = ApiState.IDLE;
      state.error = '';
    },
    setCartData: (state, action: PayloadAction<TCart>) => {
      state.cart = action.payload;
      state.status = ApiState.SUCCESS;
      state.error = '';
    }
  }
});

export const { 
  cartLoading, 
  cartSuccess, 
  cartError, 
  clearCart, 
  setCartData 
} = unlmtdCartSlice.actions;

export default unlmtdCartSlice.reducer;